import * as Yup from "yup";

export const courseSchema = Yup.object().shape({
  subjectId: Yup.string().required("Subject is required"),
  subjectName: Yup.string().required("Subject Name is required"),
  courseHeaderId: Yup.string().required("Course Header is required"),
  courseHeaderName: Yup.string().required("Course Header Name is required"),
  levels: Yup.array()
    .of(
      Yup.object().shape({
        // id: Yup.string().required("Level ID is required"),
        name: Yup.string().required("Level Name is required"),
        // courseHeaderId: Yup.string().required("Course Header ID is required"),
      })
    )
    .test(
      "atLeastOneLevel",
      "At least one level is required",
      function (value) {
        return value && value.length > 0;
      }
    ),
});

export const slotSchema = Yup.array().of(
  Yup.object().shape({
    label: Yup.string().required(),
    day: Yup.string().required(),
    checked: Yup.boolean().required(),
    times: Yup.array()
      .of(
        Yup.object().shape({
          startTime: Yup.string().required(),
          endTime: Yup.string().required(),
        })
      )
      .min(1, "At least one time slot must be defined")
      .required("At least one time slot must be defined"),
  })
);

export const teacherEducationSchema = Yup.object().shape({
  qualification: Yup.string().required("Qualification is required"),
  institute: Yup.string().required("Institute is required"),
  grade: Yup.string().required("Grade is required"),
  passingYear: Yup.string().required("Passing year is required"),
  subject: Yup.string().required("Subject is required"),
});

export const teacherTeachingAreaSchema = Yup.object().shape({
  area: Yup.number().required("Area is required"),
  city: Yup.number().required("City is required"),
  country: Yup.number().required("Country is required"),
  province: Yup.number().required("Province is required"),
});

export const teacherAcademicExperianceSchema = Yup.object().shape({
  position: Yup.string().required("Position is required"),
  organization: Yup.string().required("Organization is required"),
  subjects: Yup.string().required("Subjects is required"),
  from: Yup.string().required("Start Date  is required"),
  to: Yup.string().required("End Date is required"),
});
export const teacherCorporateExperianceSchema = Yup.object().shape({
  position: Yup.string().required("Position is required"),
  organization: Yup.string().required("Organization is required"),
  designation: Yup.string().required("Designation is required"),
  from: Yup.string().required("Start Date  is required"),
  to: Yup.string().required("End Date is required"),
});

export const profileSchema = Yup.object().shape({
  fatherOrHusbandName: Yup.string().required("Father Name is required"),
  address: Yup.string().required("Address is required"),
  CNIC: Yup.number().required("Field is required"),
  phoneNumber: Yup.string().required("Phone Number is required"),
  gender: Yup.string().required("Gender is required"),

  countryId: Yup.number().required("Country is required"),
  provinceId: Yup.number().required("Province is required"),
  cityId: Yup.number().required("City is required"),
  areaId: Yup.number().required("Area is required"),
  qualificationLevelId: Yup.number().required("Qualification is required"),
});

export const signUpAddressSchema = Yup.object().shape({
  countryId: Yup.number().required("Country is required"),
  provinceId: Yup.number().required("Province is required"),
  cityId: Yup.number().required("City is required"),
  areaId: Yup.number().required("Area is required"),
});

